import StarIcon from './StarIcon'

export default StarIcon
